module.exports = __webpack_public_path__ + "static/media/speaker.903e2a90.png";